export enum PositionTabStatus {
  Available = "Available to pay",
  UnableToPay = "Unable to pay",
  Paid = "Paid",
}

export enum UnableToPayReason {
  NoPaymentInstructions = "No payment instructions",
  UnsupportedMethod = "Unsupported method",
  InvalidInstructions = "Invalid instructions",
  ExceedsTransactionLimit = "Exceeds transaction limit",
  PendingScreeningReview = "Pending screening review",
  InvalidAmount = "Invalid amount",
  PendingPaymentInstructionChanges = "Pending payment instruction changes",
  PendingPicrComplianceChecks = "Pending compliance checks",
}

export enum InvalidPaymentInstructionReason {
  General = "general",
  BBI = "BBI",
  ReferenceToBeneficiaryLength = "referenceToBeneficiaryLength",
}

export const MAX_REFERENCE_TO_BENEFICIARY_LENGTH = 16;

export const PAYMENT_PREF_INVALID_INSTRUCTIONS_GENERAL_TOOLTIP_TEXT =
  "There are issues with the payment instructions associated with this position. Please review and correct them before this position can be paid.";

export const PAYMENT_PREF_INVALID_INSTRUCTIONS_BBI_TOOLTIP_TEXT =
  "Bank to Bank Information (BBI) fields will not be transmitted with the payments. Please remove the BBI associated with this payment instruction.";

export const PAYMENT_PREF_INVALID_INSTRUCTIONS_REFERENCE_TOOLTIP_TEXT =
  "The reference to beneficiary field for these payment instructions is too long. Please update the information stored in the reference to beneficiary to be 16 characters or less.";

export const INVALID_PAYMENT_INSTRUCTIONS_TOOLTIP_TEXT = {
  [InvalidPaymentInstructionReason.General]:
    PAYMENT_PREF_INVALID_INSTRUCTIONS_GENERAL_TOOLTIP_TEXT,
  [InvalidPaymentInstructionReason.BBI]: PAYMENT_PREF_INVALID_INSTRUCTIONS_BBI_TOOLTIP_TEXT,
  [InvalidPaymentInstructionReason.ReferenceToBeneficiaryLength]:
    PAYMENT_PREF_INVALID_INSTRUCTIONS_REFERENCE_TOOLTIP_TEXT,
};

export const PAYMENT_INSTRUCTIONS_UPDATED_TAG_TEXT = "Payment instructions updated";
export const PAYMENT_INSTRUCTIONS_UPDATED_TOOLTIP_TEXT =
  "The payment instructions have been updated. By proceeding with the payment, the user acknowledges the account has been reviewed according to the compliance policy.";
